import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { Alert, AlertIcon } from '@/components/ui/alert';
import { toast } from '@/hooks/shared/use-toast';
import { ENVIRONMENTS } from '@/const';
import { useTranslation } from 'react-i18next';

interface FallbackProps {
  error: Error;
  componentStack?: string;
  resetError?: () => void;
}

function ErrorDescription(props: { message: string | undefined; stack: string | undefined }) {
  return process.env.NODE_ENV === ENVIRONMENTS.Development ? (
    <>
      <div>▶︎ {props.message}</div>
      <div>▶︎ {props.stack}</div>
    </>
  ) : null;
}

const Fallback = ({ error }: FallbackProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    toast({
      variant: 'destructive',
      title: t('general.errors.communication'),
      description: <ErrorDescription message={error?.message} stack={error?.stack} />,
    });

    Sentry.captureException(error);
  }, []);

  return (
    <div className="p-2 w-full">
      <Alert variant="left-accent" className="rounded-lg p-2">
        <AlertIcon />
        <div className="w-full text-sm font-semibold">
          <div>{t('general.errors.communication')}</div>
          <ErrorDescription message={error?.message} stack={error?.stack} />
        </div>
      </Alert>
    </div>
  );
};

export default Fallback;
